import React from 'react';

/**@param {any} props*/
const ATable = ({ title = '', headers, rows, className, rowClassNames }) => {
  return (
    <div className={'ATable ' + (className ?? '')}>
      {title ? <span className="title">{title}</span> : null}
      <table className="h-full">
        <thead>
          <tr>
            {headers.map((header) => (
              <th key={header}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => {
            return (
              <tr key={index} className={rowClassNames?.[index]}>
                {row.map((elem, rowIndex) => (
                  <td key={row + '' + rowIndex}>{elem}</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ATable;
